import { IOmniaMaintenance, IOmniaMaintenanceService } from "../types"
import { setDates } from "../utils/date"
import { isDate } from "../utils/utils"

/** @internal */
export class OmniaMaintenanceService implements IOmniaMaintenanceService {

    private _timeout: ng.IPromise<any>

    private _current: IOmniaMaintenance
    private _next: IOmniaMaintenance

    static $inject = ["$http", "$timeout"]

    constructor(private $http: ng.IHttpService, private $timeout: ng.ITimeoutService) {

        this.$timeout(100).then(() => this.update())

    }

    update() {

        if (this._timeout) {
            this.$timeout.cancel(this._timeout)
            this._timeout = undefined
        }

        return this.$http.get("/maintenance.json").then(r => {

            let m: IOmniaMaintenance = <IOmniaMaintenance>r.data

            this._current = undefined
            this._next = undefined

            if (m && m.startDate) {

                setDates([m], ["startDate", "endDate"], false)

                if (isDate(m.startDate)) {

                    m = {
                        ...m,
                        message: formatMessage(m)
                    }

                    const now = new Date()

                    this._current = (m.startDate <= now) && ((m.endDate || now) >= now) ? m : undefined
                    this._next = this._current ? undefined : m

                }

            }

            this._timeout = this.$timeout(() => this.update(), 5 * 60 * 1000)

        }

        )

    }


    get current() {
        return this._current
    }

    get next() {
        return this._next
    }


}


function formatMessage(mnt: IOmniaMaintenance) {

    let { message: msg, startDate: start, endDate: end } = mnt

    msg = msg.replace("{startDate}", start.toLocaleDateString())
    msg = msg.replace("{startTime}", start.toLocaleTimeString(undefined, <any>{ timeStyle: "short" }))
    msg = msg.replace("{start}", start.toLocaleString())

    msg = msg.replace("{endDate}", end.toLocaleDateString())
    msg = msg.replace("{endTime}", end.toLocaleTimeString(undefined, <any>{ timeStyle: "short" }))
    msg = msg.replace("{end}", end.toLocaleString())

    return msg

}
